// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContentBanner_wrapper___hddV"};